import { render, staticRenderFns } from "./Tipo.vue?vue&type=template&id=ce785110&"
import script from "./Tipo.vue?vue&type=script&lang=js&"
export * from "./Tipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports